import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  viewChild,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CabinetPhotoUploaderComponent } from './cabinet-photo-uploader.component';

@Component({
  selector: 'lib-order-media-uploader',
  imports: [TranslatePipe, CabinetPhotoUploaderComponent],
  template: `
    <section class="order-media-uploader">
      <header class="order-media-uploader__header">
        <h2 class="order-media-uploader__title">
          {{ 'CLIENT.CABINET.MEDIA.ORDER_SECTION_TITLE' | translate }}
        </h2>
        <p class="order-media-uploader__hint">
          @if (orderId()) {
            {{ 'CLIENT.CABINET.MEDIA.ORDER_SECTION_HINT' | translate }}
          } @else {
            {{ 'CLIENT.CABINET.MEDIA.ORDER_SECTION_PENDING' | translate }}
          }
        </p>
      </header>

      @if (orderId()) {
        <lib-cabinet-photo-uploader
          entityType="order"
          [entityId]="orderId()!"
          [maxFiles]="maxFiles()"
          [allowVideo]="true"
          accept="image/jpeg,image/png,image/webp,video/mp4,video/webm"
          listAriaLabel="CLIENT.CABINET.MEDIA.ORDER_LIST_LABEL"
          emptyTitleKey="CLIENT.CABINET.MEDIA.ORDER_EMPTY_TITLE"
          emptyHintKey="CLIENT.CABINET.MEDIA.ORDER_EMPTY_HINT"
        />
      }
    </section>
  `,
  styles: `
    .order-media-uploader__header {
      margin-bottom: 12px;
    }

    .order-media-uploader__title {
      margin: 0 0 4px;
      font-size: 18px;
      font-weight: 600;
    }

    .order-media-uploader__hint {
      margin: 0;
      font-size: 14px;
      opacity: 0.75;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderMediaUploaderComponent {
  readonly orderId = input<string | null>(null);
  readonly maxFiles = input(10);

  readonly uploader = viewChild(CabinetPhotoUploaderComponent);

  readonly canUpload = computed(() => !!this.orderId()?.trim());

  uploadAll(options?: { guestPhotoUploadToken?: string }): Promise<void> {
    return this.uploader()?.uploadAll(options) ?? Promise.resolve();
  }

  successfulMediaIds(): string[] {
    return this.uploader()?.successfulMediaIds() ?? [];
  }
}
